























































import { defineComponent, ref, toRef, watch } from "@vue/composition-api";
import { debounce } from "lodash";
import { UserVerificationStatus } from "@scrile/api-provider/dist/api/UserVerificationProvider";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import emitter from "@/lib/emitter";
import { PostFileData } from "@/types";
import { EVENTS } from "@/const";
import BaseAvatar from "@/components/BaseAvatar";
import BaseIcon from "@/components/BaseIcon";
import SearchUsersWithDropdown from "@/components/SearchUsersWithDropdown";

export default defineComponent({
  name: "TagUserController",
  components: {
    SearchUsersWithDropdown,
    BaseAvatar,
    BaseIcon,
  },
  props: {
    fileList: { type: Array as () => PostFileData[] },
    taggedUserIds: { type: Array as () => string[], default: () => [] },
  },
  setup(props, { emit }) {
    const usersLoading = ref(false);
    const showTaggedInput = ref(false);
    const showController = ref(true);
    const userNameValue = ref("");
    const usersList = ref<UserPublicData[]>([]);
    const selectedUsersList = ref<UserPublicData[]>([]);
    const { authUserStrict } = useAuthUser();

    const searchUsers = debounce(async () => {
      if (!userNameValue.value) {
        usersList.value = [];
        return;
      }
      try {
        usersLoading.value = true;
        const response = await providers.UserPublicDataProvider.search({
          data: {
            role: "creator",
            relevantTerm: userNameValue.value,
            verificationStatus: UserVerificationStatus.VERIFIED,
            page: 0,
            size: 20,
          },
        });
        usersList.value = response.result.filter(i => i.id !== authUserStrict.value.id);
      } finally {
        usersLoading.value = false;
      }
    }, 500);

    const getSelectedUsers = async () => {
      if (!props.taggedUserIds?.length) return;
      selectedUsersList.value = (
        await providers.UserPublicDataProvider.search({
          data: {
            id: props.taggedUserIds,
            page: 0,
            size: 1000,
          },
        })
      ).result;
      if (selectedUsersList.value.length) {
        showTaggedInput.value = true;
        emitter.emit(EVENTS.SET_TAGGED_USERS, false);
      }
    };

    const hideTaggedInput = () => {
      showTaggedInput.value = false;
      showController.value = false;
      userNameValue.value = "";
      usersList.value = [];
      selectedUsersList.value = [];
      emitter.emit(EVENTS.SET_TAGGED_USERS, false);
    };
    const addToSelectedUsers = (user: UserPublicData) => {
      if (selectedUsersList.value.some(item => item.id === user.id)) return;
      selectedUsersList.value.push(user);
      emitter.emit(EVENTS.SET_TAGGED_USERS, false);
      emit(
        "changeTaggedUsers",
        selectedUsersList.value.map(item => item.id)
      );
    };
    const removeFromSelectedUsers = (user: UserPublicData) => {
      selectedUsersList.value = selectedUsersList.value.filter(item => item.id !== user.id);
      if (!selectedUsersList.value.length) {
        emitter.emit(EVENTS.SET_TAGGED_USERS, true);
      }
      emit(
        "changeTaggedUsers",
        selectedUsersList.value.map(item => item.id)
      );
    };

    const hideController = () => {
      showController.value = false;
      emitter.emit(EVENTS.SET_TAGGED_USERS, false);
    };

    watch(userNameValue, () => {
      searchUsers();
    });

    watch(toRef(props, "fileList"), (value, oldValue) => {
      if (value && oldValue && value?.length > oldValue?.length && !showController.value) {
        showController.value = true;
        emitter.emit(EVENTS.SET_TAGGED_USERS, true);
      }
    });

    getSelectedUsers();

    return {
      usersLoading,
      userNameValue,
      usersList,
      selectedUsersList,
      addToSelectedUsers,
      removeFromSelectedUsers,
      hideTaggedInput,
      hideController,
      showTaggedInput,
      showController,
    };
  },
});
